import { useController } from "react-hook-form";
import { FormHelperText } from "@chakra-ui/react";
import CreatableTextInput from "components/inputs/CreatableTextInput";
import { InputWrapper, InputWrapperProps } from "./FormInputs";

const CreatableTextFormInput = ({ id, ...rest }: InputWrapperProps) => {
  const { field } = useController({ name: id });

  return (
    <InputWrapper id={id} {...rest}>
      <CreatableTextInput {...field} />
      <FormHelperText>{rest.placeholder}</FormHelperText>
    </InputWrapper>
  );
};

export default CreatableTextFormInput;
